/**
 * Google Analytics(2/2) JavaScript部分
 * Google アナリティクス 4 対応済。
 * developer.k1kun@gmail.com のアカウントで解析内容を閲覧できます。
 *
 * @type {*|*[]}
 * @author Google Analytics自動生成
 * @since 2020/10/9
 */
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'UA-180154788-1');
